import React, { useEffect } from "react";
import { useGetFetchNew } from "../../data/Queries";
import { total_balance_left } from "../../data/ApiEndpoints";
import { convertThenFormat } from "../../components/common-data/Converts";
import Loader from "../../components/ui/Loader";
import icon1 from "../../images/reward/rewardHeaderIcon1.png";
import icon2 from "../../images/reward/rewardHeaderIcon2.png";

const TotalBalanceLeft = ({ userInfoData }) => {
  const { data, isLoading, refetch, isFetching } = useGetFetchNew({
    token: userInfoData?.token,
    key: "total_balance_left",
    url: `${total_balance_left}`,
    filters: {},
  });

  return (
    <div className="totalBalanceLeft">
      <div className="totalBalanceLeft__inner">
        <h4>
          Total Balance <br className="DesktopHide__br" /> Left
        </h4>
        <div className="totalBalanceLeft__inner__amount">
          {isLoading ? (
            <Loader />
          ) : (
            <p>₹{convertThenFormat(data?.data?.balance)}</p>
          )}
        </div>
      </div>
      <div className="totalBalanceLeft__icons">
        <img
          src={icon1}
          alt="icon1"
          className="totalBalanceLeft__icons__icon1"
        />
        <img
          src={icon2}
          alt="icon2"
          className="totalBalanceLeft__icons__icon2"
        />
      </div>
    </div>
  );
};

export default TotalBalanceLeft;
